// Preserve nested fields as columns and keep one CSV row per record.
const flattenRecord = (
  record: Record<string, unknown>,
  prefix = ""
): Record<string, unknown> => {
  const result: Record<string, unknown> = {};
  Object.entries(record).forEach(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (Array.isArray(value)) {
      if (
        value.every(
          (item) => item && typeof item === "object" && !Array.isArray(item)
        )
      ) {
        const items = value.map((item) => flattenRecord(item));
        const fields = Array.from(
          new Set(items.flatMap((item) => Object.keys(item)))
        );
        fields.forEach((field) => {
          result[`${path}.${field}`] = items
            .map((item) => item[field] ?? "")
            .join("; ");
        });
      } else {
        result[path] = JSON.stringify(value);
      }
    } else if (value !== null && typeof value === "object") {
      Object.assign(
        result,
        flattenRecord(value as Record<string, unknown>, path)
      );
    } else {
      result[path] = value;
    }
  });
  return result;
};

const csvCell = (value: unknown): string => {
  let text = value == null ? "" : String(value);
  // Prevent text fields from being evaluated as spreadsheet formulas.
  if (typeof value === "string" && /^[\s]*[=+@-]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
};

export const recordsToCsv = (records: object[]): string => {
  const rows = records.map((record) =>
    flattenRecord(record as Record<string, unknown>)
  );
  const headers = Array.from(new Set(rows.flatMap((row) => Object.keys(row))));
  if (!headers.length) return "\uFEFF";
  return (
    "\uFEFF" +
    [
      headers.map(csvCell).join(","),
      ...rows.map((row) =>
        headers.map((header) => csvCell(row[header])).join(",")
      ),
    ].join("\r\n")
  );
};

export const downloadCsv = (records: object[], filename: string): void => {
  const url = URL.createObjectURL(
    new Blob([recordsToCsv(records)], {
      type: "text/csv;charset=utf-8;",
    })
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
